import { motion } from 'framer-motion'
import { CoworkLogo } from '@/components/ui/CoworkLogo'

const lineVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: (delay: number) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.5, ease: 'easeOut' as const, delay },
  }),
}

const steps = [
  { n: '01', title: 'เรียนคอร์ส', desc: 'พัฒนาทักษะ' },
  { n: '02', title: 'สร้างโปรไฟล์', desc: 'แสดงผลงาน' },
  { n: '03', title: 'ค้นหาโอกาส', desc: 'ในการทำงาน' },
]

// Panel ใช้ร่วมกันระหว่าง Login/Register เพื่อให้ฝั่งซ้ายเหมือนกันทุกพิกเซล
export function AuthBrandPanel() {
  return (
    <div className="relative hidden w-[55%] shrink-0 overflow-hidden bg-[#F8F7FF] lg:flex">
      {/* Dot-grid background, matching homepage hero language */}
      <div
        className="pointer-events-none absolute -inset-4"
        style={{
          backgroundImage: 'radial-gradient(rgba(108,99,255,0.3) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      {/* Decorative shapes kept clear of the text column (which sits within max-w-lg, left-aligned) */}
      <div className="pointer-events-none absolute right-[-4rem] top-[-3rem] h-64 w-64 rotate-12 rounded-[40px] bg-accent/10" />
      <div className="pointer-events-none absolute right-10 top-1/2 h-48 w-48 -translate-y-1/2 -rotate-6 rounded-[40px] bg-accent2/10" />
      <div className="pointer-events-none absolute bottom-[-5rem] right-[-3rem] h-72 w-72 rotate-45 rounded-[40px] bg-[#4DA3FF]/10" />

      <motion.div
        initial={{ opacity: 0, x: -24 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.55, ease: 'easeOut' }}
        className="relative z-10 flex w-full max-w-lg flex-col justify-center px-14 py-16"
      >
        <CoworkLogo />

        <p className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-accent">
          LEARNING · COMMUNITY · OPPORTUNITY
        </p>

        <h1 className="mt-4 font-display text-5xl font-extrabold !leading-[1.15] xl:text-6xl">
          <motion.span
            custom={0.1}
            initial="hidden"
            animate="visible"
            variants={lineVariants}
            className="block text-[#19172A]"
          >
            LEARN.
          </motion.span>
          <motion.span
            custom={0.2}
            initial="hidden"
            animate="visible"
            variants={lineVariants}
            className="block text-[#19172A]"
          >
            GROW.
          </motion.span>
          <motion.span
            custom={0.3}
            initial="hidden"
            animate="visible"
            variants={lineVariants}
            className="text-gradient block"
          >
            GET HIRED.
          </motion.span>
        </h1>

        <p className="mt-6 max-w-sm text-base leading-relaxed text-text-muted">
          พัฒนาทักษะ สร้างโปรไฟล์
          <br />
          และค้นหาโอกาสใหม่ในที่เดียว
        </p>

        <div className="mt-10 flex items-start gap-6">
          {steps.map((step) => (
            <div key={step.n} className="flex-1">
              <span className="text-sm font-bold text-accent">{step.n}</span>
              <p className="mt-1.5 text-sm font-semibold text-[#19172A]">{step.title}</p>
              <p className="text-xs text-text-muted">{step.desc}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
